/**
 * Smile Launcher Controller - Show launcher only on /pages/rewards
 * 
 * This script controls the visibility of the Smile launcher widget.
 * It hides the launcher by default on all pages except /pages/rewards
 * to prevent unwanted launcher visibility across the site.
 */

(function() {
  'use strict';

  // Check if current page should show the Smile launcher
  function shouldShowSmileLauncher() {
    return window.location && window.location.pathname === '/pages/rewards';
  }

  // Show or hide the Smile launcher container
  function updateLauncherVisibility(container) {
    if (!container) return;

    if (shouldShowSmileLauncher()) {
      // Show launcher on rewards page
      container.style.setProperty('display', 'block', 'important');
      console.debug('[Smile Launcher Controller] Launcher shown on rewards page');
    } else {
      // Keep hidden on all other pages
      container.style.setProperty('display', 'none', 'important');
      console.debug('[Smile Launcher Controller] Launcher hidden on non-rewards page');
    }
  }

  // Handle existing container if already present
  function handleExistingContainer() {
    const container = document.querySelector('#smile-ui-container');
    if (container) {
      updateLauncherVisibility(container);
      return true;
    }
    return false;
  }

  // Set up observer for late injection of Smile container
  function setupContainerObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if this node is the Smile container
              if (node.id === 'smile-ui-container') {
                updateLauncherVisibility(node);
                observer.disconnect(); // Stop observing once we've handled it
                console.debug('[Smile Launcher Controller] Observer found and handled Smile container');
                return;
              }
              
              // Check if this node contains the Smile container
              const smileContainer = node.querySelector && node.querySelector('#smile-ui-container');
              if (smileContainer) {
                updateLauncherVisibility(smileContainer);
                observer.disconnect(); // Stop observing once we've handled it
                console.debug('[Smile Launcher Controller] Observer found and handled nested Smile container');
                return;
              }
            }
          }
        }
      }
    });

    // Observe the entire document for changes
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    console.debug('[Smile Launcher Controller] DOM observer set up');
  }

  // Initialize the controller
  function init() {
    console.debug('[Smile Launcher Controller] Initializing on path:', window.location.pathname);
    
    // First, try to handle any existing container
    const containerFound = handleExistingContainer();
    
    // If no container found yet, set up observer for late injection
    if (!containerFound) {
      setupContainerObserver();
    }
  }

  // Run on DOMContentLoaded to ensure early execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded, run immediately
    init();
  }
})();